import React from 'react';
import Hero from '../../components/pages/Contact/Hero/Hero';
import Form from '../../components/pages/Contact/Form/Form';
import Speak from '../../components/pages/Contact/Speak/Speak';
import LookingForPartner from '../../components/pages/About/LookingForPartner/LookingForPartner';

const Contact = () => {
  return (
    <div>
      <Hero />
      <Form />
      <Speak />
      <LookingForPartner />
    </div>
  );
};

export default Contact;
